import {useEffect, useState} from "react";

import {sessionCache} from "@pg-rp/session-cache";

import {ASKED_ABOUT_LOCATION} from "../../app/constants/storage_keys";

export const useGeolocationStorage = () => {
    const [locationAsked, setLocationAsked] = useState<boolean>(false);

    const checkGeolocationStorage = () => {
        return sessionCache.get<boolean>(ASKED_ABOUT_LOCATION) || false;
    };

    useEffect(() => {
        const locationInfo = checkGeolocationStorage();

        if (locationInfo) {
            setLocationAsked(locationInfo);
        }
    }, []);

    const saveGeolocationStorage = () => {
        sessionCache.set(ASKED_ABOUT_LOCATION, true);
        setLocationAsked(true);
    };

    return {locationAsked, checkGeolocationStorage, saveGeolocationStorage};
};
import {useEffect, useState} from "react";

import {sessionCache} from "@pg-rp/session-cache";

import {ASKED_ABOUT_LOCATION} from "../../app/constants/storage_keys";

export const useGeolocationStorage = () => {
    const [locationAsked, setLocationAsked] = useState<boolean>(false);

    const checkGeolocationStorage = () => {
        return sessionCache.get<boolean>(ASKED_ABOUT_LOCATION) || false;
    };

    useEffect(() => {
        const locationInfo = checkGeolocationStorage();

        if (locationInfo) {
            setLocationAsked(locationInfo);
        }
    }, []);

    const saveGeolocationStorage = () => {
        sessionCache.set(ASKED_ABOUT_LOCATION, true);
        setLocationAsked(true);
    };

    return {locationAsked, checkGeolocationStorage, saveGeolocationStorage};
};
